/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnHA1Lq%7Btransition%3Aopacity%20.5s%20ease%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNs7dHp%7Bopacity%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNsdnbC%7Bopacity%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnH5NQM%7Btransition%3Abox-shadow%20.5s%20ease%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtSqWv%7Bbox-shadow%3A0%208px%209pt%20rgba(9%2C30%2C66%2C0)%2C0%200%201px%20rgba(9%2C30%2C66%2C0)%7D");
import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import AIGlowingBorder from './ai-glowing-border';
import { AI_BORDER_PALETTE } from './constants';
import type { AIPrismProps } from './types';
const contentStyles = null;
const contentStylesPrismVisible = null;
const animatedSvgContainerStyles = {
  true: "_23rrnHA1Lq _1YKVNs7dHp",
  false: "_23rrnHA1Lq _1YKVNsdnbC"
};
const borderRadiusStyles = {
  large: "_0bjKvD8fU6",
  small: "_0bjKvDKxmn"
};
const popupContainerStyles = null;
const AIPrism = ({
  borderRadius,
  children,
  isGlowing = true,
  isMoving = true,
  isVisible,
  testId
}: AIPrismProps): JSX.Element => {
  const {
    colorMode = 'light'
  } = useThemeObserver();
  return <AIGlowingBorder palette={AI_BORDER_PALETTE[colorMode] ?? AI_BORDER_PALETTE.light} isGlowing={isGlowing} isMoving={isMoving} testId={testId} className={ax([animatedSvgContainerStyles[isVisible ? 'true' : 'false'], borderRadius && borderRadiusStyles[borderRadius]])}>
			<div className={ax(["_0bjKvD8fU6 _0KLXruoI2d _2OUyjtGk8v", "_23rrnH5NQM", isVisible && "_2OUyjtSqWv"])}>
				{children}
			</div>
		</AIGlowingBorder>;
};
export default AIPrism;